import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-product-tos',
  templateUrl: './report-product-tos.component.html',
  styleUrls: ['./report-product-tos.component.css']
})
/** Report: product terms-of-service — stub component with no logic yet. */
export class ReportProductTosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
